export default __webpack_public_path__ + "static/media/bathroom1-before-1440w.5df79bbf.avif";